import * as ActionTypes from '../actionTypes';

const initialState = {
    listGroups: [],
    listRoles: [],
    roleDetails: [
        {
            group: 'payments',
            label: 'Payments',
            roles: [
                { key: 'view', label: 'View' },
                { key: 'create', label: 'Create' },
            ],
        },
        {
            group: 'conversions',
            label: 'Conversions',
            roles: [
                { key: 'view', label: 'View' },
                { key: 'create', label: 'Create' },
            ],
        },
        {
            group: 'beneficiaries',
            label: 'Beneficiaries',
            roles: [
                { key: 'view', label: 'View' },
                { key: 'create', label: 'Create' },
            ],
        },
        {
            group: 'payroll',
            label: 'Payroll',
            roles: [
                { key: 'view', label: 'View' },
                { key: 'create', label: 'Create' },
            ],
        },
        {
            group: 'cards',
            label: 'Cards',
            roles: [
                { key: 'manage', label: 'Manage' },
                { key: 'user', label: 'User' },
            ],
        },
        {
            group: 'billing',
            label: 'Billing',
            roles: [{ key: 'manage', label: 'Manage' }],
        },
        {
            group: 'users',
            label: 'Users',
            roles: [
                { key: 'invite', label: 'Invite' },
                { key: 'manage', label: 'Manage' },
            ],
        },
        {
            group: 'company',
            label: 'Company',
            roles: [{ key: 'manage', label: 'Manage' }],
        },
    ],
};

export default function reducer(state = initialState, action) {
    let object;
    switch (action.type) {
        case ActionTypes.COMPLETE_GET_ROLE_LIST:
            const listGroups = action.payload?.map((item) => {
                return { key: item.Id, label: item.Name };
            });

            listGroups.push({
                key: 'Custom',
                label: 'Custom',
            });

            object = {
                listGroups,
                listRoles: action.payload,
            };
            return { ...state, ...object };
        default:
            return state;
    }
}
